import { render, staticRenderFns } from "./LibraryFilterButton.vue?vue&type=template&id=54462353"
import script from "./LibraryFilterButton.vue?vue&type=script&lang=js"
export * from "./LibraryFilterButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports